<div class="filter">
  <div>Filtrar por</div>
  <ul class="filter-options">
    <li class="option" *ngFor="let option of filterOptions; let i = index" 
      [ngClass]="{'active': option.selected}" (click)="selectOption(i)">
      {{option.label}}
    </li>
  </ul>
</div>